// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import i18n from './language';
import { sync } from 'vuex-router-sync';
import { hookFlashMessagesAtRouter } from '@/store/modules/flash-messages';
import { hookBreadcrumpAtRouter } from '@/store/modules/breadcrumb';


import './assets/scss/main.scss'

import LoaderButton from './components/elements/Input/LoaderButton';
Vue.component('loader-button', LoaderButton);

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'
import regular from '@fortawesome/fontawesome-free-regular'
import 'font-awesome/css/font-awesome.min.css'
fontawesome.library.add(solid, regular)
Vue.component('fa-icon', FontAwesomeIcon);

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime);

hookFlashMessagesAtRouter(router);
hookBreadcrumpAtRouter(router);
sync(store, router);

Vue.mixin({
	methods: {
		logValue(value) {
			console.log(value);
		},

		capitalize: (string) => string.toLowerCase().replace(/(^|\s|-)\S/g, l => l.toUpperCase()),
	}
});

/* eslint-disable no-new */
export default new Vue({
	el: '#app',
	store,
	router,
	i18n,
	render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js